import { useState, SetStateAction } from 'react';
import { toast } from 'react-toastify';
import toastr from 'toastr';
import { EditorState } from 'draft-js';
import legacy from '../../../../../../services/api/axios';
import axios from 'axios';

const useMailBlast = () => {
  const [params, setParams] = useState({ type: '' });
  const [customers, setCustomers] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [selectedBasestations, setSelectedBasestations] = useState([]);
  const [selectedAccessPoints, setSelectedAccessPoints] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [subject, setSubject] = useState('');
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [body, setBody] = useState('');
  const [country, setCountry] = useState('');
  const [canned, setCanned] = useState('');
  const onSubjectChange = (e) => {
    setSubject(e.target.value);
  };
  const onCannedChange = (e) => {
    setCanned(e.target.value);
  };
  const onCountryChange = (e) => {
    setCountry(e.target.value);
  };
  const onTextChange = (e) => {
    setBody(e.target.value);
  };

  const onChange = (e) => {
    setParams({ ...params, [e.target.name]: e.target.value });
  };

  const handleChange = (option) => {
    setSelectedOption(option ? option.map((opt) => opt.value) : []);
    setSelectedBasestations(option || []);
  };

  const handleAccessPointChange = (selected) => {
    setSelectedAccessPoints(selected || []);
  };
  const onSubmit = async () => {
    if (!selectedBasestations.length) {
      toast("Please select a basestation");
      return;
    }

    setFetching(true);
    const token = sessionStorage.getItem("token");

    try {
      const endpoint = selectedAccessPoints.length
        ? "https://api.tizeti.com/api/v1/geniatech/access_point_users"
        : "https://api.tizeti.com/api/v1/legacy/UsersByBasestation";

      const response = await axios.post(
        endpoint,
        {
          type: params.type,
          // calledstation: selectedBasestations.map(opt => opt.value),
          access_point_id: selectedAccessPoints.map(opt => opt.value),
    
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setCustomers(response.data);
    } catch (error) {
      toast("Something went wrong!");
      console.error(error);
    } finally {
      setFetching(false);
    }
  };

  const sendEmail = async (param) => {
    setSendingEmail(true);
    try {
      const response = await axios.post('https://api.tizeti.com/api/v1/mail/mailblast', param, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      });
      if (response.data.status === true) {
        toastr.success('Sent Successfully' || response.data.message);
        setEditorState(EditorState.createEmpty());
        setSubject('');
        setSendingEmail(false);
      } else {
        toast.info('Unable to send message');
        setSendingEmail(false);
      }
    } catch (error) {
      toast('Something went wrong. Try later!');
      setSendingEmail(false);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const submitForm = () => {};

  const onEditorStateChange = (editorStat) => {
    setEditorState(editorStat);
  };
  return {
    onChange,
    onSubmit,
    handleChange,
    handleAccessPointChange,
    selectedBasestations,
    selectedAccessPoints,
    customers,
    fetching,
    sendEmail,
    sendingEmail,
    onEditorStateChange,
    submitForm,
    editorState,
    subject,
    onSubjectChange,
    onTextChange,
    body,
    country,
    onCountryChange,
    canned,
    onCannedChange,
  };
};
export default useMailBlast;
